import { render, staticRenderFns } from "./SuccessResetPassword.vue?vue&type=template&id=aafa80be&"
import script from "./SuccessResetPassword.vue?vue&type=script&lang=js&"
export * from "./SuccessResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports